/**
 * Created by Ning Jiang on 10/16/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class TombstoneSuperFreespinSymbolWPController extends WinPresentationController {

    private _timeline:TimelineLite | null;
    private _superFreespinTrigered:boolean;
    private _bonusPositions:number[];
    private _scatterPositions:number[];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "SuperFreespinSymbol"})
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._superFreespinTrigered = data.superFreespinTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._scatterPositions = data.scatterPositions!;

        if(this._superFreespinTrigered && (
            this._scatterPositions == null ||
            this._scatterPositions[1] === -1 ||
            this._scatterPositions[2] === -1 ||
            this._scatterPositions[3] === -1 ||
            this._bonusPositions == null ||
            this._bonusPositions[0] === -1 ||
            this._bonusPositions[4] === -1)) {
            debugger;
            throw new Error("TombstoneScatterSymbolWPController.parseFeatureGameData(): scatterPositions data doesn't match the feature.")
        }
    }

    protected hasWin():boolean {
        return this._superFreespinTrigered;
    }

    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({paused : true, onComplete : () => this.finish()});
        timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BONUS_WIN), 0);
        timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SCATTER_WIN), 0);
        timeline.add(this.getWinSymbolAnimation(0, this._bonusPositions[0], false), 0);
        timeline.add(this.getWinSymbolAnimation(1, this._scatterPositions[1], false), 0);
        timeline.add(this.getWinSymbolAnimation(2, this._scatterPositions[2], false), 0);
        timeline.add(this.getWinSymbolAnimation(3, this._scatterPositions[3], false), 0);
        timeline.add(this.getWinSymbolAnimation(4, this._bonusPositions[4], false), 0);

        this._timeline = timeline;
        this._timeline.play();
    }

    private getWinSymbolAnimation(reelId:number, symbolId:number, isAbort:boolean):Timeline | null {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol == null) {
            debugger;
            return null;
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : isAbort ? 0 : 0.1,
            frames : isAbort ? [-1, -1] : [0]
        })!;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
            this._timeline = null;
        }
        this.getWinSymbolAnimation(0, this._bonusPositions[0], true);
        this.getWinSymbolAnimation(1, this._scatterPositions[1], true);
        this.getWinSymbolAnimation(2, this._scatterPositions[2], true);
        this.getWinSymbolAnimation(3, this._scatterPositions[3], true);
        this.getWinSymbolAnimation(4, this._bonusPositions[4], true);
    }

    protected resetFeature():void {
    }
}